import { render, staticRenderFns } from "./ModalAddAcompMensal.vue?vue&type=template&id=518b12f6"
import script from "./ModalAddAcompMensal.vue?vue&type=script&lang=js"
export * from "./ModalAddAcompMensal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports